module.exports = __webpack_public_path__ + "img/tickets.3395e733.svg";